/** ReserveNature permit mode labels (match backend `permit-modes.js`). */
export const PERMIT_MODE_OVERNIGHT = 'Overnight';
export const PERMIT_MODE_OVERNIGHT_EXITING_MT_WHITNEY =
  'Overnight Exiting Mt Whitney';

export const RECREATION_GOV_TYPE_OVERNIGHT = 'overnight-permit';
export const RECREATION_GOV_TYPE_OVERNIGHT_EXITING_MT_WHITNEY =
  'overnight-exiting-mt-whitney';

/** recreation.gov land-permit app entity_ids (accept `type` on detailed-availability). */
export const RECREATION_GOV_LAND_PERMIT_ENTITY_IDS = new Set([
  '233262',
  '445856',
  '74984',
  '445857',
  '445858',
  '445859',
  '445860',
  '445861',
  '445862',
  '445863',
  '445864',
]);

export function recreationGovTypeFromPermitMode(mode) {
  if (mode === PERMIT_MODE_OVERNIGHT_EXITING_MT_WHITNEY) {
    return RECREATION_GOV_TYPE_OVERNIGHT_EXITING_MT_WHITNEY;
  }
  if (mode === PERMIT_MODE_OVERNIGHT) {
    return RECREATION_GOV_TYPE_OVERNIGHT;
  }
  return null;
}

/** @param {{ permitModes?: string[] } | null | undefined} outing */
export function recreationGovTypeFromOuting(outing) {
  const modes = outing?.permitModes;
  if (!Array.isArray(modes) || modes.length === 0) return null;
  for (const mode of modes) {
    const type = recreationGovTypeFromPermitMode(mode);
    if (type) return type;
  }
  return null;
}

export function isRecreationGovLandPermitEntity(entityId) {
  return RECREATION_GOV_LAND_PERMIT_ENTITY_IDS.has(String(entityId));
}

export function buildRecreationGovPermitBookingUrl({ entityId, date, permitType }) {
  const base = `https://www.recreation.gov/permits/${entityId}/registration/detailed-availability`;
  const params = new URLSearchParams();
  if (date) params.set('date', date);
  if (permitType) params.set('type', permitType);
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}

/**
 * Calendar / blog booking link for recreation.gov permits.
 * @param {{ outing?: { entity_id?: string, permitModes?: string[] }, date?: string }} params
 */
export function buildRecreationGovPermitBookingUrlForOuting({ outing, date }) {
  const entityId = outing?.entity_id;
  if (!entityId) return 'https://www.recreation.gov';
  let permitType = recreationGovTypeFromOuting(outing);
  if (!permitType && isRecreationGovLandPermitEntity(entityId)) {
    permitType = RECREATION_GOV_TYPE_OVERNIGHT;
  }
  return buildRecreationGovPermitBookingUrl({ entityId, date, permitType });
}
